import { render } from "./Modal.vue?vue&type=template&id=f6c2d376&scoped=true"
import script from "./Modal.vue?vue&type=script&lang=js"
export * from "./Modal.vue?vue&type=script&lang=js"

import "./Modal.vue?vue&type=style&index=0&id=f6c2d376&lang=scss&scoped=true"

import exportComponent from "D:\\Projects\\Jesta\\Front\\Jesta-Group\\Dashboard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f6c2d376"]])

export default __exports__